import { fetcher } from "helpers/fetcher";

import { TGetReportingLineReq, TGetReportingLineRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEodReportingLine = async (payload: TGetReportingLineReq) => {
  return await fetcher<TGetReportingLineRes, TGetReportingLineReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_EOD_REPORTING_LINE,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
      urlData: { date: payload.data.date },
    }
  );
};

export const queryGetEodReportingLine = async (
  payload: TGetReportingLineReq
) => {
  return (await getEodReportingLine(payload)).data;
};

queryGetEodReportingLine._key = (payload?: TGetReportingLineReq) => [
  ENDPOINT.MANAGEMENT.GET_EOD_REPORTING_LINE.url,
  payload,
];
